export const timelineActionTypes = {
    TIMELINE_REQUESTED: 'TIMELINE_REQUESTED',
    TIMELINE_RECEIVED: 'TIMELINE_RECEIVED',
    TIMELINE_ERROR: 'TIMELINE_ERROR',
    TIMELINE_PROCESSING: 'TIMELINE_PROCESSING',
    TIMELINE_COUNT_RECEIVED: 'TIMELINE_COUNT_RECEIVED',

    TIMELINE_GROUP_COUNT_RECEIVED: 'TIMELINE_GROUP_COUNT_RECEIVED',
    TIMELINE_GROUP_COUNT_REQUESTED: 'TIMELINE_GROUP_COUNT_REQUESTED',
    TIMELINE_GROUP_COUNT_ERROR: 'TIMELINE_GROUP_COUNT_ERROR'
};


// WEBPACK FOOTER //
// ./src/timeline/actions/timeline-action-types.js